import React from "react";
import { useHistory } from "react-router-dom";
import SetPassword from "../../../components/VendorComponents/VendorLogin/LoginScreen/SetPassword";
import { getServerKey } from "../../../services/encription/encriptionServices";
import {
  decryption,
  encryption,
  hashingFeatures,
} from "../../../services/encription/encryption";
import { vendorResetPassword } from "../../../services/login/loginApiService";
import { keyClockclient } from "../../Constants/commenFeatures";
import { RoutesUrl } from "../../Routes/constents";

export interface VendorSetPasswordState {
  disableForm: boolean;
  errorMsg?: string;
  popupMessage?: string;
}

const VendorSetPassword: React.FC = () => {
  // login starts with LOGIN screen
  const [loginCtrl, setLoginCtrl] = React.useState<VendorSetPasswordState>({
    disableForm: false,
    errorMsg: undefined,
  });

  const [resetPasswordCtrl, setResetPasswordCtrl] = React.useState<any>({
    otp: "",
    password: "",
    confirmPassword: "",
  });

  const history = useHistory();

  const submitSetPasswordForm = async () => {
    await getServerKey(getServerTokenRes);
  };

  const getServerTokenRes = async (res: any, newResp: any) => {
    var SPK = newResp.headers.get("SPK");

    if (res && res.error) {
      setLoginCtrl({
        disableForm: true,
        errorMsg: "Something went wrong, Please try again later",
      });
    } else {
      const hashPassword = await hashingFeatures(resetPasswordCtrl.password);
      let jsonData = JSON.stringify({
        otp: resetPasswordCtrl.otp,
        emailId: localStorage.getItem("email"),
        newPassword: hashPassword,
        client: keyClockclient,
      });
      // Here we are encrypt the data
      let encrypedForm = await encryption(SPK, jsonData);
      vendorResetPassword(
        submitSetPasswordFormRes,
        encrypedForm.reqObj,
        encrypedForm.header
      );
    }
  };

  const submitSetPasswordFormRes = async (res: any, newResp: any) => {
    if (res && res.error) {
      setLoginCtrl({
        disableForm: true,
        errorMsg: res.error.errorMessage,
      });
    } else if (res && res.response) {
      let CEPRK = newResp.headers.get("CEPRK");

      // After getting response we need to decrypt the response
      let decryptedData = await decryption(CEPRK, res.response);
      console.log("decryptedData", decryptedData);

      if (decryptedData && decryptedData.status) {
        history.push(RoutesUrl.VendorLogin);
      }
    } else {
      setLoginCtrl({
        disableForm: true,
        errorMsg: "Request failed",
      });
    }
  };

  const onClose = () => {
    history.push(RoutesUrl.Home);
  };

  const removeError = () => {
    setLoginCtrl({
      disableForm: false,
      errorMsg: undefined,
    });
  };

  const getScreen = () => {
    return (
      <div className="vendor_login">
        <SetPassword
          disableForm={loginCtrl.disableForm}
          onSubmit={submitSetPasswordForm}
          errorMsg={loginCtrl.errorMsg}
          onRemoveError={removeError}
          onClose={onClose}
          resetForm={resetPasswordCtrl}
          onChange={setResetPasswordCtrl}
        />
      </div>
    );
  };

  return <div>{getScreen()}</div>;
};

export default VendorSetPassword;
